import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="Breadcrumb" className="px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 max-w-7xl mx-auto">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors">
            {t("breadcrumb.home")}
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center"></i>
            {item.path && index < items.length - 1 ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}